'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.NavLink = exports.Nav = exports.Container = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  @media (', ') {\n    flex-direction: column;\n  }\n'], ['\n  @media (', ') {\n    flex-direction: column;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  flex-shrink: 0;\n  box-sizing: border-box;\n  padding-right: 8px;\n  width: 190px;\n  border-right: 1px solid rgba(0, 0, 0, 0.30);\n\n  @media (', ') {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 8px;\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.30);\n  }\n\n  > div > h3 {\n    font-size: 16px;\n    line-height: 1.3;\n  }\n'], ['\n  flex-shrink: 0;\n  box-sizing: border-box;\n  padding-right: 8px;\n  width: 190px;\n  border-right: 1px solid rgba(0, 0, 0, 0.30);\n\n  @media (', ') {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 8px;\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.30);\n  }\n\n  > div > h3 {\n    font-size: 16px;\n    line-height: 1.3;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: block;\n  margin-bottom: 4px;\n  padding-top: 4px;\n  padding-left: 4px;\n  padding-bottom: 4px;\n\n  color: ', ';\n  border-left: 3px solid transparent;\n  font-weight: ', ';\n\n  text-decoration: none;\n\n  &:focus:not(:active) {\n    border-left: 3px solid ', ';\n    outline: none;\n  }\n'], ['\n  display: block;\n  margin-bottom: 4px;\n  padding-top: 4px;\n  padding-left: 4px;\n  padding-bottom: 4px;\n\n  color: ', ';\n  border-left: 3px solid transparent;\n  font-weight: ', ';\n\n  text-decoration: none;\n\n  &:focus:not(:active) {\n    border-left: 3px solid ', ';\n    outline: none;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 16px;\n'], ['\n  padding-left: 16px;\n']);

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('styled-material/dist/src/colors');

var _layout = require('styled-material/dist/src/layout');

var _styles = require('../../styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = exports.Container = (0, _styledComponents2.default)(_layout.Row)(_templateObject, _styles.mobile);
var Nav = exports.Nav = _styledComponents2.default.nav(_templateObject2, _styles.mobile);
var NavLink = exports.NavLink = (0, _styledComponents2.default)(_reactRouterDom.Link)(_templateObject3, _colors.materialColors['indigo-500'], function (_ref) {
  var active = _ref.active;
  return active ? 500 : 400;
}, _colors.materialColors['pink-a400']);
var Content = exports.Content = _styledComponents2.default.section(_templateObject4);
//# sourceMappingURL=sidenav-layout.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/components/ui/sidenav-layout.js